import React, { FC } from 'react';
import { ColorSelect } from 'components/forms';
import { ITextInputWrapper } from './TextInputWrapper';

const ColorSelectWrapper: FC<ITextInputWrapper> = (props) => {
  const { input, meta, render, children, ...otherProps } = props;

  return <ColorSelect {...input} {...meta} {...otherProps} />;
};

export default ColorSelectWrapper;
